// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__AxbVY","content":"RecentSearches_content__2iZ1x"};